<template>
  <v-banner
    v-if="isVisible"
    rounded 
    elevation="5" 
    lines="three"
    :bg-color="bgColor"
    :style="{ borderColor: brColor }"
  >
    <v-banner-text>
      <div class="v-banner-text-title" v-html="title"></div>
      <div 
        :class="{ 'v-banner-text-description' : title }" 
        v-html="description"
      ></div>
    </v-banner-text>
    <v-banner-actions
      :style="{ borderLeftColor: brColor }"
    >
      <v-btn 
        v-if="showClose"
        icon="mdi-close"
        variant="plain"
        @click="isVisible = false">
      </v-btn>
    </v-banner-actions>
  </v-banner>
</template>

<script>
export default {
  name: 'Banner',
  props: {
    title: {
      type: String,
      default: ''
    },
    description: {
      type: String,
      default: ''
    },
    showClose: {
      type: Boolean,
      default: false
    },
    bgColor: {
      type: String,
      default: ''
    },
    brColor: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      isVisible: true
    }
  }
};
</script>

<style lang="scss" scoped>
  .v-banner {
    position: absolute;
    right: 0;
    z-index: 100;
    padding: 0px;
    border-width: 1px;
    border-style: solid;

    &-text {
      padding: 10px;
      font-family: var(--primary-font-family-name);
      font-size: 16px;
      font-weight: 500;
      line-height: 20px;
      color: rgba(var(--black-color, 1));

      &-title {
        font-weight: 600;
      }

      &-description {
        font-weight: 400;
        color: rgba(var(--gunsmoke-color, 1));
      }
    }

    &-actions {
      height: 100%;
      align-items: center;
      margin: 0px !important;
      border-left-width: 1px;
      border-left-style: solid;
    }
  }
</style>